// extracted by mini-css-extract-plugin
export default {"mainContainer":"Game_mainContainer__CPsp6","modalContainer":"Game_modalContainer__yoPKr"};